import { cn } from "../lib/cn.ts";
import type { HTMLProps } from "../lib/props.ts";

/** Shared field chrome — keeps Input, Textarea and Select visually identical. */
export const FIELD_BASE =
  "w-full rounded-md border border-input bg-card px-3 text-sm " +
  "text-foreground placeholder:text-muted-foreground " +
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring " +
  "focus-visible:ring-offset-2 focus-visible:ring-offset-background " +
  "disabled:cursor-not-allowed disabled:opacity-50";

export interface InputProps extends Omit<HTMLProps<"input">, "size"> {
  /** Renders the field in its error state and marks it for assistive tech. */
  invalid?: boolean;
}

export function Input({
  invalid,
  placeholder,
  class: klass,
  className,
  ...props
}: InputProps) {
  return (
    <input
      aria-invalid={invalid || undefined}
      placeholder={placeholder ?? " "}
      className={cn(
        FIELD_BASE,
        "h-10",
        invalid && "border-danger focus-visible:ring-danger",
        klass,
        className,
      )}
      {...props}
    />
  );
}

export interface TextareaProps extends HTMLProps<"textarea"> {
  invalid?: boolean;
}

export function Textarea({
  invalid,
  class: klass,
  className,
  ...props
}: TextareaProps) {
  return (
    <textarea
      aria-invalid={invalid || undefined}
      className={cn(
        FIELD_BASE,
        "min-h-20 py-2",
        invalid && "border-danger focus-visible:ring-danger",
        klass,
        className,
      )}
      {...props}
    />
  );
}
